// extracted by mini-css-extract-plugin
export default {"searchContainer":"Searching_searchContainer__1z9JH","searchHeader":"Searching_searchHeader__3VK9e"};